'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _stringsAndConstants = require('./strings-and-constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

require('./cancel-subscription-form.scss');

var _ref = _jsx('li', {});

var _ref2 = _jsx('br', {});

var _ref3 = _jsx('div', {
    className: 'm-settings--cancel--hr'
});

var CancelSubscriptionForm = _baseForm2['default'].createFormClass({

    displayName: 'CancelSubscriptionForm',

    propTypes: {
        'isHf': _react2['default'].PropTypes.bool, // maybe get dynamically from helpers
        'isTeamAdmin': _react2['default'].PropTypes.bool,
        'hasHipaa': _react2['default'].PropTypes.bool,
        'hasBothApiAndUiPlans': _react2['default'].PropTypes.bool,
        'redirectUrl': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            supportShouldContact: false,
            supportMessage: "",
            justApi: false,
            justUi: false,
            // Individual fields to hide (not sections, such as competitor or support contact)
            showFields: {
                'cancel_reason_features-detail': false
            },
            // Competitor info
            cancelForCompetitor: false,
            competitorName: "",
            competitorAutocompleteMatches: [],
            shouldShowCompetitorAutocomplete: false,
            shouldShowCompetitorReasons: false,
            // Validation
            hasAttemptedSubmit: false,
            supportShouldContactFilled: false,
            atLeastOneReasonChecked: false,
            errors: {}
        };
    },

    /**
    * Handlers
    */

    onCompetitorAutocompleteItemClick: function onCompetitorAutocompleteItemClick(e) {
        var text = e.target.innerHTML;
        this.setState({
            competitorName: text,
            shouldShowCompetitorAutocomplete: false
        });
    },

    onSupportMessageChange: function onSupportMessageChange(e) {
        var message = e.target.value;

        this.setState({
            supportMessage: message
        });
    },

    onPlanSwitchChange: function onPlanSwitchChange(e) {

        var newState = {};

        if (e.target.name === 'cancel[just_ui]') {
            newState.justUi = e.target.checked;
        } else if (e.target.name === 'cancel[just_api]') {
            newState.justApi = e.target.checked;
        }

        this.setState(newState);
    },

    onReasonListChange: function onReasonListChange(e) {

        var newState = {};
        newState.atLeastOneReasonChecked = document.querySelectorAll("input[type='checkbox']:checked").length > 0;

        if (e.target.name === 'cancel[cancel_reason_features]') {
            newState.showFields = {};
            newState.showFields['cancel_reason_features-detail'] = e.target.checked;
        }

        if (e.target.name === 'cancel[cancel_reason_competitor]') {
            newState.cancelForCompetitor = e.target.checked;
        }

        this.setState(newState);
    },

    onCompetitorNameChange: function onCompetitorNameChange(e) {
        var name = e.target.value;
        var list = [];

        if (name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD) {
            // Cheap implentation of autocomplete, but enough for this case
            var re = new RegExp(name, "i");
            list = _stringsAndConstants.cancelConstants.competitorList.filter(function (competitor) {
                return competitor.match(re);
            });
        }

        this.setState({
            competitorName: name,
            competitorAutocompleteMatches: list,
            shouldShowCompetitorAutocomplete: name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD,
            shouldShowCompetitorReasons: name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD
        });
    },
    onSupportShouldContactChange: function onSupportShouldContactChange(e) {
        var shouldContact = e.target.value === 'yes' ? true : false;
        this.setState({
            supportShouldContactFilled: true,
            supportShouldContact: shouldContact
        });
    },

    onCanWeFollowUpChange: function onCanWeFollowUpChange(e) {},

    onSubmit: function onSubmit(e) {

        // Validation
        this.setState({ hasAttemptedSubmit: true });
        var valid = this.validateForm() && this.validateSupportMessage() && this.validatePlanSwitch();
        console.log("valid says ", valid);

        e.preventDefault();
        if (valid) {
            $('#cancel_form').submit();
        }
    },

    /**
    * Validation
    */

    validateForm: function validateForm() {
        if (this.state.supportShouldContactFilled && this.state.atLeastOneReasonChecked) {
            return true;
        }
        return false;
    },

    validateSupportMessage: function validateSupportMessage() {

        // Don't need to fill in if no contact needed
        if (!this.state.supportShouldContact) {
            return true;
        }

        if (this.state.supportMessage.length >= _stringsAndConstants.cancelConstants.SUPPORT_MESSAGE_MIN_THRESHOLD) {
            return true;
        }

        return false;
    },

    validatePlanSwitch: function validatePlanSwitch() {

        if (!this.props.hasBothApiAndUiPlans) {
            return true;
        }

        if (this.state.justUi || this.state.justApi) {
            return true;
        }

        return false;
    },

    /**
    * Sub render methods
    */

    renderCancelWarning: function renderCancelWarning() {
        var legalText = this.props.isHf ? _stringsAndConstants.cancelStrings.legalText.HF : _stringsAndConstants.cancelStrings.legalText.HS;
        return _jsx('span', {}, void 0, legalText.head, _jsx('a', {
            href: 'info/tos'
        }, void 0, ' ', legalText.link, ' '), legalText.tail);
    },

    renderPlanSwitch: function renderPlanSwitch() {

        var self = this;

        var error = this.state.hasAttemptedSubmit && !this.state.justUi && !this.state.justApi;

        var justApiToggle = this.renderField('just_api', {
            'data-format': 'inputcheckbox',
            'value': this.state.justApi,
            'onChange': self.onPlanSwitchChange
        });

        var justUiToggle = this.renderField('just_ui', {
            'data-format': 'inputcheckbox',
            'value': this.state.justUi,
            'onChange': self.onPlanSwitchChange
        });

        return _jsx('div', {
            className: 'm-settings--cancel--plan-switch-container'
        }, void 0, _jsx('div', {
            className: 'm-settings--cancel--api-option'
        }, void 0, justApiToggle, _jsx('label', {
            htmlFor: 'cancel_just_api'
        }, void 0, 'Cancel API plan  '), justUiToggle, _jsx('label', {
            htmlFor: 'cancel_just_ui'
        }, void 0, 'Cancel web plan')), _jsx('div', {
            className: 'm-settings--cancel--error'
        }, void 0, error ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0));
    },

    renderYesNoToggle: function renderYesNoToggle(fieldName, sectionLabelName, onChange) {

        var sectionLabel = _jsx('h2', {}, void 0, sectionLabelName);

        var yes = this.renderField(fieldName, {
            'tabIndex': 2,
            'data-format': 'selectradio',
            'onChange': onChange,
            'name': fieldName,
            'value': 'yes'
        });
        var yesLabel = _jsx('label', {
            htmlFor: fieldName
        }, void 0, 'Yes');
        var no = this.renderField(fieldName, {
            'tabIndex': 2,
            'data-format': 'selectradio',
            'onChange': onChange,
            'name': fieldName,
            'value': 'no'
        });
        var noLabel = _jsx('label', {
            htmlFor: fieldName
        }, void 0, 'No');
        return _jsx('div', {
            className: 'm-settings--cancel--toggle-container'
        }, void 0, sectionLabel, yes, yesLabel, no, noLabel);
    },

    renderReasonForCancelList: function renderReasonForCancelList() {
        return this.renderReasonsList('cancel_reason', _stringsAndConstants.cancelStrings.cancelReasons);
    },

    renderCompetitorReasonList: function renderCompetitorReasonList() {
        return this.renderReasonsList('competitor_reason', _stringsAndConstants.cancelStrings.competitorReasons);
    },

    renderReasonsList: function renderReasonsList(namePrefix, namesToReasonLabelMap) {
        var self = this;
        var regex = new RegExp(namePrefix);
        var reasons = this.props.fields.filter(function (field) {
            return field.name && field.name.match(regex);
        });

        var list = [];
        reasons.forEach(function (reason) {
            var component;
            switch (reason.type) {
                case 'inputcheckbox':
                    var field = self.renderField(reason.name, {
                        'tabIndex': 2,
                        'data-format': 'inputcheckbox',
                        'onChange': self.onReasonListChange,
                        'name': reason.name,
                        'key': reason.name
                    });
                    var label = _jsx('label', {
                        htmlFor: reason.name
                    }, void 0, namesToReasonLabelMap[reason.name]);
                    component = _jsx('li', {
                        className: 'm-settings--cancel--reason-list--item'
                    }, void 0, field, label);
                    break;
                case 'textarea':
                    if (self.state.showFields.hasOwnProperty(reason.name) && !self.state.showFields[reason.name]) {
                        component = void 0;
                    } else {
                        var field = self.renderField(reason.name, {
                            'tabIndex': 2,
                            'data-format': 'textarea',
                            'onChange': self.onReasonListChange,
                            'name': reason.name,
                            'key': reason.name,
                            'placeholder': _stringsAndConstants.cancelStrings.placeholders[reason.name]
                        });
                        component = _jsx('li', {}, void 0, field);
                    }
                    break;
                default:
                    component = _ref;
            }
            list.push(component);
        });

        return _jsx('ul', {
            className: 'm-settings--cancel--reason-list'
        }, void 0, list);
    },

    renderTeamAdminWarning: function renderTeamAdminWarning() {
        return _jsx('span', {}, void 0, _ref2, _stringsAndConstants.cancelStrings.teamAdminWarning);
    },


    renderCompetitorAutocomplete: function renderCompetitorAutocomplete() {
        var _this = this;

        var matches = this.state.competitorAutocompleteMatches;
        if (this.state.shouldShowCompetitorAutocomplete) {
            return _jsx('div', {
                className: 'm-settings--cancel--competitor-autocomplete'
            }, void 0, _jsx('ul', {}, void 0, matches.map(function (match) {
                return _jsx('li', {
                    className: 'm-settings--cancel--competitor-autocomplete--item',
                    onClick: _this.onCompetitorAutocompleteItemClick
                }, void 0, match);
            })));
        }
    },

    /**
    * Main render
    */

    render: function render() {

        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var siteCode = this.props.isHf ? _hfReactHelper2['default'].HfSites.SITE_CODE_HF : _hfReactHelper2['default'].HfSites.SITE_CODE_HS;

        var reminderList = this.props.isHf ? void 0 : _jsx('div', {
            className: 'm-settings--cancel--reminder'
        }, void 0, _jsx('div', {
            className: 'm-settings--cancel--reminder--title'
        }, void 0, 'FREE ACCOUNTS DON\'T INCLUDE'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, 'Unlimited documents'), _jsx('li', {}, void 0, 'Templates'), _jsx('li', {}, void 0, 'In-person signing'), _jsx('li', {}, void 0, 'Two-factor Authentication'), this.props.hasHipaa ? _jsx('li', {}, void 0, 'HIPAA compliance') : void 0));

        var supportShouldContactToggle = this.renderYesNoToggle('support_should_contact', 'Do you need a Support Representative to follow up with you?', this.onSupportShouldContactChange);

        var supportMessageTextArea = this.renderField('support_message', {
            'tabIndex': tabOffset + 1,
            'placeholder': 'Please briefly describe the issue',
            'data-format': 'textarea',
            'onChange': this.onSupportMessageChange
        });

        var supportError = !this.state.supportShouldContactFilled && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0;
        var supportMessageError = !this.validateSupportMessage() && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.messageTooShort : void 0;

        var customerSupportInfo = _jsx('div', {
            className: 'm-settings--cancel--support'
        }, void 0, supportShouldContactToggle, this.state.supportShouldContact ? supportMessageTextArea : void 0, _jsx('div', {
            className: 'm-settings--cancel--error'
        }, void 0, supportError, supportMessageError));

        var canWeFollowUpToggle = this.renderYesNoToggle('can_provide_more_info', 'Would you be willing to provide more information about your experience if needed?', this.onCanWeFollowUpChange);

        var competitorNameField = this.renderField('competitor_name', {
            'tabIndex': tabOffset + 1,
            'placeholder': "Please enter the name of the company you've chosen",
            'data-format': 'input',
            'onChange': this.onCompetitorNameChange,
            'value': this.state.competitorName
        });

        var competitorAutocomplete = this.renderCompetitorAutocomplete();

        var competitorReasons = this.state.shouldShowCompetitorReasons ? _jsx('div', {
            className: 'm-settings--cancel--reason-container'
        }, void 0, _jsx('h2', {}, void 0, 'Please indicate your reasons for choosing them :'), _jsx('h4', {}, void 0, 'Please select all that apply.'), this.renderCompetitorReasonList()) : void 0;

        var competitorInfo = this.state.cancelForCompetitor ? _jsx('div', {
            className: 'm-settings--cancel--competitor-info'
        }, void 0, competitorNameField, competitorAutocomplete, competitorReasons) : void 0;

        var reasonsError = !this.state.atLeastOneReasonChecked && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0;

        var cancellationAndCompetitorReasons = _jsx('div', {
            className: 'm-settings--cancel--reason-container'
        }, void 0, _jsx('h2', {}, void 0, 'Why are you canceling your service with us?'), _jsx('h4', {}, void 0, 'Please select all that apply.'), this.renderReasonForCancelList(), competitorInfo, _jsx('div', {
            className: 'm-settings--cancel--error'
        }, void 0, reasonsError));

        var customerComments = _jsx('div', {}, void 0, _jsx('h2', {}, void 0, 'Anything else you\'d like to tell us?'), this.renderField('customer_comments', {
            'tabIndex': tabOffset + 1,
            'placeholder': "Thank you so much for taking the time to provide us with feedback.",
            'data-format': 'textarea'
        }));

        var cancelLegalWarning = _jsx('p', {
            className: 'm-settings--cancel--warning'
        }, void 0, this.renderCancelWarning(), this.props.isTeamAdmin ? this.renderTeamAdminWarning() : void 0);

        var ctaButtons = _jsx('div', {
            className: 'm-settings--cancel--actions'
        }, void 0, _jsx('div', {
            id: 'cancelSubscriptionButton'
        }, void 0, _jsx(_button2['default'], {
            buttonText: 'Cancel my subscription',
            buttonLink: '#',
            buttonColor: 'grasshopper',
            buttonClass: 'border-1-grasshopper',
            buttonTextColor: 'white',
            buttonHoverTextColor: 'white',
            buttonHoverColor: 'castle-rock',
            buttonHoverBorderColor: 'castle-rock',
            type: 'submit',
            onClick: this.onSubmit
        })), _jsx('div', {
            id: 'nevermindButton'
        }, void 0, _jsx(_button2['default'], {
            buttonText: 'Never mind',
            buttonLink: _hfReactHelper2['default'].urlHelper('home/myAccount?current_tab=billing', siteCode),
            buttonColor: 'white',
            buttonClass: 'border-1-grasshopper',
            buttonTextColor: 'grasshopper',
            buttonHoverTextColor: 'white',
            buttonHoverColor: 'grasshopper'
        })));

        return _jsx('form', {
            id: 'cancel_form',
            name: 'cancel_form',
            className: 'account-form',
            method: 'POST'
        }, void 0, this.renderHiddenFields(), _jsx('h1', {}, void 0, 'Are you sure you want to cancel?'), _jsx('h3', {
            className: 'm-cancel--subtitle'
        }, void 0, 'Canceling your paid account will downgrade your service to a Free account.'), reminderList, _ref3, _jsx('h3', {}, void 0, 'If you do decide to cancel, we would really appreciate learning about your experience using HelloSign.'), customerSupportInfo, cancellationAndCompetitorReasons, canWeFollowUpToggle, customerComments, cancelLegalWarning, this.props.hasBothApiAndUiPlans ? this.renderPlanSwitch() : void 0, _jsx('input', {
            type: 'hidden',
            name: 'redirect_url',
            value: this.props.redirectUrl ? redirectUrl : ""
        }), this.renderErrorText(), ctaButtons);
    }

});

module.exports = CancelSubscriptionForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/cancel-subscription/cancel-subscription-form.jsx
 ** module id = 771
 ** module chunks = 0
 **/